const errorMessagesMapping = {
    "auth/user-not-found": "No account found with this email. Please sign up.",
    "auth/wrong-password": "Incorrect password. Try again or reset it.",
    "auth/invalid-email": "The email address is not valid.",
    "auth/email-already-in-use": "This email is already registered. Please login.",
    "auth/too-many-requests": "Too many failed attempts. Try again later.",
    "auth/network-request-failed": "Network error. Please check your internet connection."
};
const getFriendlyFirebaseError = (error) => {
    if (!error || !error.code) return "Something went wrong. Please try again.";

    return errorMessagesMapping[error.code] || "An unexpected error occurred.";
}

export default getFriendlyFirebaseError;

